<template lang="pug">
div
  .bin-related__title
    div
      span#related_cards_title {{ relatedCardListTitle() }}
  #bin-related__items(:class='relatedListClass')
    .row
      div.px-3(v-for="card in cardListToggle" :key="card.id" :class="fullItemClass")
        bin-card-related-item-vue(
          :title="card.title"
          :domain="card.domain",
          :full_view="fullView",
        )
  .d-flex.justify-content-center
    button.btn.btn-primary#related_cards_see_more_btn(
      v-if='showSeeMoreButton' @click='seeTotalCardsToggle'
    ) {{ seeMoreLabel }}
</template>

<script>
import mixins from "common/mixins"
import { mapState } from 'vuex'

export default {
  name: 'bin-card-related-list-vue',
  components: {
    "bin-card-related-item-vue": () => import(
      /* webpackChunkName: "[request]" */ "components/bin_card/BINCardRelatedItem"
    )
  },
  props: {
    relatedCards: { type: Array, default: () => [] },
    fullView: { type: Boolean, default: false }
  },
  data() {
    return {
      seeMoreButton: true,
      isCollapsed: true
    }
  },
  computed: {
    cardListToggle() {
      return this.isCollapsed ?
        this.shortCardList() :
        this.relatedCards
    },
    relatedListClass() {
      if (this.totalCardsQuantity > this.minimumCards()) {
        return this.isCollapsed ? "bin-related-collapsed" : "bin-related-expanded"
      } else {
        return "bin-related-expanded"
      }
    },
    seeMoreLabel() {
      return this.isCollapsed ?
        I18n.t("components.bin_card.see_more") :
        I18n.t("components.bin_card.see_less")
    },
    totalCardsQuantity() {
      return this.relatedCards.length;
    },
    foundCardMessage() {
      return this.totalCardsQuantity > 1 ?
        I18n.t("components.bin_card.have_been_found") :
        I18n.t("components.bin_card.has_been_found")
    },
    relatedCardsMessage() {
      return this.totalCardsQuantity > 1 ?
        I18n.t("components.bin_card.related_cards") :
        I18n.t("components.bin_card.related_card")
    },
    fullItemClass() {
      return this.fullView ? "col-md-3 bin-related-item-full" : "col-12 px-0"
    },
    showSeeMoreButton() {
      return this.relatedCards.length > this.minimumCards() && this.seeMoreButton
    },
    ...mapState('search', ['searchTokens'])
  },
  mixins: [mixins.translate],
  methods: {
    seeTotalCardsToggle() {
      return this.isCollapsed = !this.isCollapsed
    },
    shortCardList() {
      return this.relatedCards.slice(0, this.minimumCards())
    },
    showSeeMoreButtonToggle() {
      this.relatedCards.length > this.minimumCards() ?
        this.seeMoreButton = true : this.seeMoreButton = false
    },
    minimumCards() {
      const fullViewQty = 12
      const shortViewQty = 3
      return this.fullView ? fullViewQty : shortViewQty
    },
    relatedCardListTitle() {
      return `${this.foundCardMessage} ${this.totalCardsQuantity} ${this.relatedCardsMessage}`
    },
  },
  watch: {
    searchTokens(){
      this.is_collapsed = true
    }
  },
  mounted() {
    this.showSeeMoreButtonToggle();
  }
}
</script>
